const gdprCountries = ['United Kingdom', 'Ireland'];

export default gdprCountries;
